import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=6b4a541c&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4a541c')) {
      api.createRecord('6b4a541c', component.options)
    } else {
      api.reload('6b4a541c', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=6b4a541c&", function () {
      api.rerender('6b4a541c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-209pZ5VOBQdYH/JS/comp/CurrentYear.vue"
export default component.exports